
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService';
import { StorageService } from '../storage';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AttendanceService } from './attendance.service';
import { AttendanceDelgate } from './attendance.delegate';
import { AuthenticationService } from '../AuthenticationService';

export class AttendanceServiceFactory {
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService): AttendanceService {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const attendanceDelegate = new AttendanceDelgate(httpProvider);

        return new AttendanceService(attendanceDelegate, authenticationService);
    }
}